import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faPenToSquare,
  faTrash,
  faKey,
  faShieldHalved,
  faBell,
  faRotateRight,
  faUsers,
  faCalendarDays,
  faDatabase,
  faEnvelope,
  faChevronDown,
  faUpRightFromSquare,
  faEyeSlash,
  faCalendarPlus,
  faBan,
  faSquareCheck,
  faBook,
  faStethoscope,
  faCopy,
  faReply,
  faCircleInfo,
  faCircleQuestion,
  faPhone,
  faMobileScreen,
  faGlobe,
  faHouse,
  faClipboardCheck,
  faGift,
  faBinoculars,
  faList,
  faFlagCheckered,
  faListCheck,
  faChartColumn
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faPenToSquare,
  faTrash,
  faKey,
  faShieldHalved,
  faBell,
  faRotateRight,
  faUsers,
  faCalendarDays,
  faDatabase,
  faEnvelope,
  faChevronDown,
  faUpRightFromSquare,
  faEyeSlash,
  faCalendarPlus,
  faBan,
  faSquareCheck,
  faBook,
  faStethoscope,
  faCopy,
  faReply,
  faCircleInfo,
  faCircleQuestion,
  faPhone,
  faMobileScreen,
  faGlobe,
  faHouse,
  faClipboardCheck,
  faGift,
  faBinoculars,
  faList,
  faFlagCheckered,
  faListCheck,
  faChartColumn
);

export { FontAwesomeIcon };
